import React, { forwardRef, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { setBreadCrumbStack } from 'components/Header/SecondaryNavigation/store/actions'
import { ContactLandingContent } from './ContactLandingContent'
import { ConfirmPopup } from 'primereact/confirmpopup'
import { Toast } from 'primereact/toast'

export const ContactLanding = forwardRef((props, ref) => {
    const location = useLocation()
    const dispatch = useDispatch()
    const setBreadCrumb = (stack) => dispatch(setBreadCrumbStack(stack))
    const toast = useRef(null)

    const breadcrumbItem = {
        label: 'Contacts',
        path: location.pathname
    }

    setBreadCrumb([breadcrumbItem])   

    return (
        <div className='application-content d-flex flex-column flex-grow-1' >
            <div className='container-fluid d-flex flex-column flex-grow-1'>
                <div className='row app-content d-flex flex-grow-1'>                     
                    <ConfirmPopup />
                    <Toast ref={toast} className="toast-right" />
                    <ContactLandingContent id={props.id} />
                </div>
            </div>
        </div>
    )
})
